import { clientWithApiClient } from "../../client";
import type { ApiClient, Response } from "../../types";
import type {
  InventoryGridRequest,
  InventoryGrid,
  UnavailableDateRangesRequest,
  UnavailableDateRange,
  ProximitySearchRequest,
  ProximitySearchGrid,
} from "./types";

/**
 * The API resolves the fleet from `fleet_id` in the query string and falls back
 * to the user's first fleet without it, so authenticated callers must pass the
 * fleet they selected. Public search widgets are scoped by their API key and
 * leave it out.
 */
const withFleet = (path: string, fleetId?: string) => {
  if (!fleetId) return path;

  const searchParams = new URLSearchParams();
  searchParams.append("fleet_id", fleetId);

  return `${path}?${searchParams.toString()}`;
};

const getGrid = (
  apiClient: ApiClient,
  params: InventoryGridRequest,
  fleetId?: string,
) =>
  clientWithApiClient<Response<InventoryGrid>>(
    apiClient,
    withFleet("/inventory/grid", fleetId),
    {
      method: "POST",
      body: JSON.stringify(params),
    },
  );

const getUnavailableDateRanges = (
  apiClient: ApiClient,
  params: UnavailableDateRangesRequest,
  fleetId?: string,
) =>
  clientWithApiClient<Response<UnavailableDateRange[]>>(
    apiClient,
    withFleet("/inventory/unavailable-date-ranges", fleetId),
    {
      method: "POST",
      body: JSON.stringify(params),
    },
  );

const proximitySearch = (
  apiClient: ApiClient,
  params: ProximitySearchRequest,
  fleetId?: string,
) =>
  clientWithApiClient<Response<ProximitySearchGrid>>(
    apiClient,
    withFleet("/inventory/proximity-search", fleetId),
    {
      method: "POST",
      body: JSON.stringify(params),
    },
  );

export const inventory = {
  getGrid,
  getUnavailableDateRanges,
  proximitySearch,
};
